import React from 'react';
import cn from 'classnames';

import Ratings from 'components/ratings';

import CompanyLogo from '../../../components/companyLogo';
import { buildCppSubpageUrl, formatNumber } from '../../../utils';
import { CPP_SUBPAGES } from '../../../utils/constant';

class CompanyClusterHeaderTitle extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { title, subPageName, data, showClaimCompanyButton } = this.props;
    const {
      claimedCompany,
      isVerifiedByEmployer,
      desktopDevice,
      jobsCountForHeader,
      showJobsCount,
      companyReviewsPage,
      subheaderItems,
    } = data;
    const {
      companyLogo,
      overallScore,
      starRatingCssName,
      companyID,
      companyNameCPS,
      companyJobsCount,
      displayFlagOfCompanyJobsPage,
      companyLink,
    } = data.companyInfo;
    const imgWidthHeight = desktopDevice ? 120 : 92.16;
    const imgWidth = imgWidthHeight;
    const imgHeight = imgWidthHeight;
    const reviewsPageLink = subheaderItems.find((item) => item.title === 'Reviews');

    const goToCompanyReviewsPage = () => {
      if (reviewsPageLink && !companyReviewsPage) window.location.href = reviewsPageLink.link;
    };

    return (
      <div className={cn('company-header-container d-flex align-content-md-center align-items-start position-relative z-mb-36 z-mt-24 z-mt-md-36 w-100')}>
        <div className={cn('company-logo-placeholder z-mr-md-16 z-ml-12 z-ml-md-0 z-pl-0')}>
          <CompanyLogo
            className="clusterHeaderCompanyLogoImg overflow-hidden"
            companyName={companyNameCPS}
            companyLogo={companyLogo}
            imgWidth={imgWidth}
            imgHeight={imgHeight}
            size="xxlarge"
          />
        </div>
        <div className="company-data-placeholder">
          {!showJobsCount && (
            <h1 className="company-cluster-header-title">
              {/* Note: the space after title below is required, DO NOT remove it. */}
              <span className="title">{title + ' '}</span>
            </h1>
          )}
          {showJobsCount && (
            <div>
              <h1 className="d-inline company-cluster-header-title">{title}</h1>
              <span className="d-inline company-cluster-header-title">{` - ${formatNumber(
                jobsCountForHeader ?? data?.companyInfoJobs?.totalJobs ?? 0
              )} Jobs`}</span>
            </div>
          )}

          <div className="company-score d-flex z-mt-12 z-mt-md-8 z-mb-16 flex-wrap gg-6">
            {overallScore && (
              <span className="smallGrey d-inline-flex align-items-center z-mr-12">
                {`Zippia Score ${overallScore}`}
                {starRatingCssName && (
                  <div onClick={goToCompanyReviewsPage} className="z-ml-12">
                    <Ratings
                      colorClass='blue'
                      disabled
                      ratingIndex={overallScore}
                      customClasses={{ star: 'extra-small' }}
                      showTitle={false}
                    />
                  </div>
                )}
              </span>
            )}
            {!!companyJobsCount &&
              displayFlagOfCompanyJobsPage &&
              subPageName !== CPP_SUBPAGES.JOBS && (
                <div className="smallGrey job-openings">
                  <a
                    href={buildCppSubpageUrl(companyLink, '', CPP_SUBPAGES.JOBS)}
                    className="alink"
                  >
                    Job Openings ({formatNumber(companyJobsCount)})
                  </a>
                </div>
              )}
          </div>

          {isVerifiedByEmployer ? (
            <button
              type="button"
              className="d-contents"
              onClick={() => (window.location.href = `/employer/signup/?companyID=${companyID}`)}
            >
              <div className="company-claim-container">
                <span className="claim-status-blue-dot" />
                <span className="company-claim-status">Verified</span>
              </div>
            </button>
          ) : (
            showClaimCompanyButton && (
              <button
                type="button"
                className="d-contents"
                onClick={() => (window.location.href = `/employer/signup/?companyID=${companyID}`)}
              >
                <div className="company-claim-container">
                  <span className="claim-status-red-dot" />
                  <span className="company-claim-status">Claim This Company</span>
                </div>
              </button>
            )
          )}

          {claimedCompany && (
            <div
              className="update-company-profile"
              onClick={() => (window.location.href = `/employer/profile/${companyID}/`)}
            >
              <span className="update-company-profile-link">Update Company Profile</span>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default CompanyClusterHeaderTitle;
